module.exports={labels:["人材","CtoC","教育","医療・ヘルスケア","飲食","HR","その他"],values:[2,2,2,3,3,7,13]};